import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => {
    // SSR-safe: check if window is available
    if (typeof window === 'undefined') {
      return false;
    }
    try {
      return window.matchMedia(query).matches;
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const mediaQuery = window.matchMedia(query);

      const handleChange = (e: MediaQueryListEvent) => {
        setMatches(e.matches);
      };

      // Modern API
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
      }

      // Legacy API fallback
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    } catch {
      return;
    }
  }, [query]);

  return matches;
};
